const PrivacyPolicy = () => import('./pages/PrivacyPolicy.vue')
const TermsAndConditions = () => import('./pages/TermsAndConditions.vue')

const legalRoutes = [
  {
    path: 'privacy-policy',
    name: 'privacy-policy',
    component: PrivacyPolicy,
  },
  {
    path: 'terms-and-conditions',
    name: 'terms-and-conditions',
    component: TermsAndConditions,
  },
]

export default legalRoutes
